// FILE IS MANAGED BY MAKEFILE. DO NOT EDIT THIS FILE DIRECTLY.
export const firebaseConfig = {
  apiKey: 'AIzaSyA7RdId6qpt_ohE7nZgr0DqR6rx2AHGxIc',
  authDomain: 'cards-collection-game.firebaseapp.com',
  projectId: 'cards-collection-game',
  storageBucket: 'cards-collection-game.appspot.com',
  messagingSenderId: '795121363213',
  appId: '1:795121363213:web:5ab2f484ac4dd2119a2844',
  measurementId: 'G-R0BBWZSMF7',
}
// helpers/firebase/emulatorsConfig.false.ts
export const useEmulators = false
